// A simple function to save the scroll position
function saveScrollPosition() {
  sessionStorage.setItem('scrollPosition', window.scrollY);
}

// A function to restore the scroll position
function restoreScrollPosition() {
  const scrollPosition = sessionStorage.getItem('scrollPosition');
  if (scrollPosition) {
    window.scrollTo(0, parseInt(scrollPosition, 10));
    sessionStorage.removeItem('scrollPosition');
  }
}

// Add event listener for when the page is loaded or retrieved from bfcache
window.addEventListener('pageshow', (event) => {
  // Use a conditional to only restore the scroll position on collection pages
  if (window.location.href.includes('/collections/')) {
    restoreScrollPosition();
  }
});

// Attach the save function to product links
document.addEventListener('DOMContentLoaded', () => {
  const productLinks = document.querySelectorAll('a[href*="/products/"]');
  productLinks.forEach(link => {
    link.addEventListener('click', saveScrollPosition);
  });
});